<template>
    <sa-page-layout :btnAnnullaVisible="true" :btnSaveVisible="true" :linkback="linkback" :data="jsonData" @aftersave="onAfterSave" :showModalLoading="showModalLoading" :pathResource="pathResource" class="sa-no-space">
        <template slot="table-body">
            <rsa-configurazione-laboratori-edit-component ref="RsaConfigurazioneLaboratoriEditComponent" :showModalLoading="showModalLoading" @update="onUpdateJsonData" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></rsa-configurazione-laboratori-edit-component>
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaConfigurazioneLaboratoriEditComponent from "../components/RsaConfigurazioneLaboratoriEditComponent.vue";

export default {
    components: { SaPageLayout, RsaConfigurazioneLaboratoriEditComponent },
    data() {
        return {
            showModalLoading: false,
            pathResource: "/rsalaboratori",
            linkback: "/configurazioni/rsaconfigurazionelaboratori",
            jsonData: {},
            id: "-1",
        };
    },
    methods: {
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onAfterSave() {
            // let me = this;
            // me.id = me.$route.params.id;
            // if (me.id === "-1") {
            //   me.$router.replace(me.linkback).catch((err) => {
            //     console.log(err);
            //   });
            // }
        },
    },
};
</script>

<style></style>
